import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-neutral-950 border-t border-white/5 py-12 px-6 mt-auto">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">

        <div className="text-center md:text-left">
          <h4 className="text-xl font-bold text-white mb-2">Refine Studio</h4>
          <p className="text-neutral-500 text-sm">
            © 2025 Refine Studio. Based in India.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8 md:gap-12">
          <a href="mailto:connect@refinestudio.space" className="group flex items-center gap-3 text-neutral-400 hover:text-white transition-colors">
            <div className="p-2 bg-white/5 rounded-full group-hover:bg-blue-600/20 group-hover:text-blue-400 transition-colors">
              <Mail size={18} />
            </div>
            <span className="text-sm">connect@refinestudio.space</span>
          </a>

          <a href="tel:+919604692411" className="group flex items-center gap-3 text-neutral-400 hover:text-white transition-colors">
            <div className="p-2 bg-white/5 rounded-full group-hover:bg-green-600/20 group-hover:text-green-400 transition-colors">
              <Phone size={18} />
            </div>
            <span className="text-sm">+91 96046 92411</span>
          </a>

          <div className="flex items-center gap-3 text-neutral-400">
            <div className="p-2 bg-white/5 rounded-full">
              <MapPin size={18} />
            </div>
            <span className="text-sm">India</span>
          </div>
        </div>
      </div>
    </footer>
  );
};